<template>
  <div
    class="rounded-lg border px-3 py-2.5"
    :class="isInternalNote ? 'bg-amber-50 border-amber-200' : 'bg-gray-50 border-gray-200'"
  >
    <!-- Author + meta -->
    <div class="flex items-center justify-between mb-1.5">
      <div class="flex items-center gap-2">
        <div
          class="w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-medium shrink-0"
          :class="isInternalNote ? 'bg-amber-200 text-amber-800' : 'bg-primary-100 text-primary-700'"
        >
          {{ authorInitials }}
        </div>
        <span class="text-xs font-medium text-gray-900 sensitive">{{ authorDisplay }}</span>
        <SourceBadge :source="comment.source" />
        <span class="text-[10px] text-gray-400">{{ relativeTime(comment.created_at) }}</span>
      </div>
    </div>

    <!-- Body -->
    <div class="text-sm text-gray-800 whitespace-pre-wrap ml-8 sensitive">{{ comment.body }}</div>

    <!-- Attachments -->
    <div v-if="attachments.length" class="ml-8 mt-2">
      <RequirementAttachmentList :files="attachments" :use-media-endpoint="true" />
    </div>
  </div>
</template>

<script>
import SourceBadge from './SourceBadge.vue';
import RequirementAttachmentList from './RequirementAttachmentList.vue';

export default {
  name: 'RequirementCommentItem',
  components: { SourceBadge, RequirementAttachmentList },
  props: {
    comment: { type: Object, required: true },
  },
  computed: {
    isInternalNote() {
      return this.comment.source === 'internal_note';
    },
    authorDisplay() {
      if (this.comment.author_name) return this.comment.author_name;
      if (this.comment.email_sender) return `Unknown sender: ${this.comment.email_sender}`;
      return 'Unknown';
    },
    authorInitials() {
      const name = this.comment.author_name || this.comment.email_sender || '?';
      const parts = name.split(/[\s@]+/);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    attachments() {
      return this.comment.attachments || [];
    },
  },
  methods: {
    relativeTime(dateStr) {
      if (!dateStr) return '';
      const diff = Date.now() - new Date(dateStr).getTime();
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return 'just now';
      if (mins < 60) return `${mins}m ago`;
      const hours = Math.floor(mins / 60);
      if (hours < 24) return `${hours}h ago`;
      const days = Math.floor(hours / 24);
      if (days < 7) return `${days}d ago`;
      return new Date(dateStr).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    },
  },
};
</script>
